import axios from "axios";
import { apiBaseUrl } from "../../../helpers/UrlHelper";
import { loginToken } from "../../../helpers/LocalStorageHelper";
import { handleError } from "../../../helpers/ErrorHelper";
import { debounce } from "../../../helpers/Debounce";
import { shallowEqual } from "react-redux";

function _success(success) {
  return { type: "GETS_DISCOUNT_SUCCESS", success };
}

function _error(error) {
  return { type: "GETS_DISCOUNT_ERROR", error };
}

function _processing(processing) {
  return { type: "GETS_DISCOUNT_PROCESSING", processing };
}

function getDiscountSlabs(shouldDebounce = false) {
  return (dispatch, getState) => {
    dispatch(_processing(true));
    dispatch(_success(null));
    dispatch(_error(null));
    let { params } = getState().discountList.data;
    const request = () =>
      axios({
        url: apiBaseUrl(`admin/discount_slabs`),
        method: "get",
        dataType: "json",
        params,
        headers: { Authorization: "Bearer " + loginToken() },
      })
        .then(function (res) {
          dispatch(_success(res.data.data));
          dispatch(_processing(false));
        })
        .catch(function (error) {
          handleError(error);
          dispatch(_error(error));
          dispatch(_processing(false));
        });

    debounce.makeRequest(request, shouldDebounce);
  };
}

export default getDiscountSlabs;
